import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-[#05080f] text-white overflow-hidden flex items-center py-20 lg:py-0" data-id="element-1">
      {/* Background Effects - Stadium Lights */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[500px] bg-blue-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-2" />
      <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-3" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-5">
          {/* Copy Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-900/30 border border-blue-500/30 text-blue-400 text-sm font-medium tracking-wide uppercase" data-id="element-7">
              <Zap size={14} className="fill-blue-400" data-id="element-8" />
              <span data-id="element-9">College Edition</span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-black tracking-tighter leading-[0.95] text-white" data-id="element-10">
              YOU'RE NOT <span className="text-gray-500" data-id="element-11">WEAK</span>. <br data-id="element-12" />
              YOU'RE{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600" data-id="element-13">
                OFFLINE
              </span>
              .
            </h1>

            <div className="space-y-6 text-lg text-gray-300 max-w-xl border-l-2 border-blue-500/30 pl-6" data-id="element-14">
              <p data-id="element-15">
                You already did the work most guys avoid. You lifted. You got
                stronger. You showed up when it was boring.
              </p>
              <p data-id="element-16">
                So why does it still feel like your power has a mind of its own?
              </p>
              <p data-id="element-17">
                Some days the barrel finds the ball and it jumps. Other days…
                the same swing feels heavy. Late. Quiet.
              </p>
              <p className="font-semibold text-white" data-id="element-18">
                That's not "mechanics." That's not "confidence." That's your
                system going offline — and nobody taught you how to turn it back
                on.
              </p>
            </div>

            <div className="pt-4" data-id="element-19">
              <a href="#pricing" onClick={e => {
              e.preventDefault();
              document.getElementById('pricing')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-blue-600 rounded-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 focus:ring-offset-[#0a0f1a]" data-id="element-20">
                <span data-id="element-21">Get the 30-Day Power System</span>
                <ChevronRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-22" />
                <div className="absolute inset-0 rounded-sm ring-2 ring-white/20 group-hover:ring-white/40 transition-all" data-id="element-23" />

                {/* Glow effect */}
                <div className="absolute -inset-3 bg-blue-500/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-24" />
              </a>
              <p className="mt-4 text-sm text-gray-500" data-id="element-25">
                Instant PDF Download • Secure Checkout
              </p>
            </div>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-26">
            <div className="relative rounded-xl overflow-hidden shadow-2xl shadow-blue-900/20 border border-white/10 group" data-id="element-27">
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1a] via-transparent to-transparent opacity-40 z-10" data-id="element-28" />
              <img src="https://cdn.magicpatterns.com/uploads/4i1ykHVGSKTzy1e8jbHzUL/hitting_power.png" alt="Explosive Baseball Power System on iPad" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" data-id="element-29" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 z-20 bg-black/80 backdrop-blur-md border border-white/10 p-4 rounded-lg" data-id="element-30">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-31">
                  System Includes
                </div>
                <div className="text-white font-bold" data-id="element-32">
                  30-Day College Power Plan
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}